import React from 'react';
import { Project } from '../../../types';

interface ProjectDescriptionProps {
  project: Project;
  canEdit: boolean;
  onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
}

const ProjectDescription: React.FC<ProjectDescriptionProps> = ({
  project,
  canEdit,
  onBlur,
}) => {
  return (
    <div className="mb-8">
      <h3 className="text-sm font-semibold text-gray-700 mb-3">Description</h3>
      {canEdit ? (
        <textarea
          defaultValue={project.description}
          onBlur={onBlur}
          placeholder="Add a description..."
          className="w-full px-4 py-3 text-sm text-gray-700 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
          rows={4}
        />
      ) : (
        <p className="text-sm text-gray-700">{project.description || 'No description'}</p>
      )}
    </div>
  );
};

export default ProjectDescription;
